import { Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CommonModule} from '@angular/common';
import { SvgComponent } from '@inspark/inspark-components';
import { ICONS_MAP } from '../../../constnts/icons-map';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, SvgComponent],
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PasswordInputComponent),
    },
  ],
})
export class PasswordInputComponent implements ControlValueAccessor {
  public disabled = false;
  @Input() required = false;
  @Input() autocomplete = 'off';
  @Input() label = false;
  @Input() errorMessage = false;
  @Input() controlname = '';
  @Input() isHidden = true;
  @Input() isInline = true;
  @Input() showLabel = true;
  public value: string;

  protected readonly ICONS_MAP = ICONS_MAP;

  constructor() {}

  public onTouched() {}

  public onChange(value: string) {}

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(this.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
